import React from 'react'
import Typography from "@mui/material/Typography";
import BookChapterLayout from '../../layout/BookChapters';

const Chapter = () => {
  return (
    <div className="mainDiv">
    <Typography className="heading">Chapter</Typography>
     <BookChapterLayout />
  
    </div>
  )
}

export default Chapter
